import AddToCartButton from '../shared/AddToCartButton';
import { buildImageUrl, LineasMeta, Bestseller } from './ProductoMeta';

/**
 * Tarjeta de producto de la sección promocional, con las medidas del video de
 * referencia: 9rem de ancho (entran dos y media), foto arriba y, pegada debajo
 * dentro de la misma tarjeta redondeada, una franja oscura con la porción y el
 * tiempo de preparación a la izquierda y el "+" a la derecha. Precio y nombre
 * van fuera, sobre el panel verde.
 *
 * Hermana de MenuProductCard (la del menú completo): comparten la franja y la
 * etiqueta Bestseller (ProductoMeta); cambian colores y tamaño.
 *
 * El "+" es el mismo AddToCartButton del resto del home, para no tener dos
 * botones distintos haciendo lo mismo. Va dentro de la franja, en la esquina,
 * así no tapa la foto ni la etiqueta del producto.
 */
export default function PromoProductCard({ product, onClick, bestsellerImage }) {
  const imagen = buildImageUrl(product.popularImage) || buildImageUrl(product.image);
  const etiqueta = product.tagId?.isActive && product.tagId?.image ? product.tagId : null;

  // Div y no <button>: AddToCartButton trae sus propios botones dentro.
  return (
    // 140px medidos en la referencia: con la primera pestaña activa, la foto del
    // primer producto llega justo al pie de esa pestaña, no la rebasa.
    <div onClick={onClick} className="w-[8.75rem] flex-shrink-0 cursor-pointer">
      <div className="relative">
        {/* Esquinas de 16px y foto 330:277, medida lado a lado con la app
            original (~118px de alto con 140 de ancho). */}
        <div className="rounded-2xl overflow-hidden bg-promo-card-strip">
          <div className="relative aspect-[330/277]">
            {imagen ? (
              <img
                src={imagen}
                alt={product.name}
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder.svg'; }}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-white/40 text-xs">
                Sin imagen
              </div>
            )}

            {etiqueta && (
              <img
                src={buildImageUrl(etiqueta.image)}
                alt={etiqueta.name}
                className="absolute bottom-1 right-1 h-7 w-auto max-w-[75%] object-contain pointer-events-none"
                loading="lazy"
              />
            )}
          </div>

          {/* Franja oscura debajo de la foto, en dos renglones como en la
              referencia: la porción (personas, piezas o ml) y el tiempo de
              preparación. */}
          <div className="h-[39px] flex flex-col justify-center gap-0.5 pl-2 pr-12 min-w-0 text-white">
            <LineasMeta product={product} />
          </div>
        </div>

        {/* Dentro de la franja verde, en la esquina de abajo a la derecha: 4px
            del lado y 6px del pie, para que no quede pegado a la orilla de
            abajo. Vive fuera del contenedor recortado para que no se le coma
            la sombra, y alineado a la derecha: al agregar crece hacia la
            izquierda. */}
        <AddToCartButton product={product} className="absolute right-1 bottom-0.5" />
      </div>

      {/* Separaciones medidas contra la original: 4px a la tarjeta, precio
          con interlineado justo y la etiqueta pegadita al nombre. */}
      <div className="pt-2 px-0.5">
        <span className="block text-[15px] leading-tight font-bold tracking-tight text-white">
          ${product.price?.toFixed(0)}
        </span>
        <h3 className="text-[13px] font-medium text-white/90 leading-snug line-clamp-2">
          {product.name}
        </h3>
        {product.isBestseller && (
          <Bestseller imagen={bestsellerImage} claseTexto="text-promo-bestseller" />
        )}
      </div>
    </div>
  );
}
